import styles from '../../assets/styles/Settings/Settings.module.scss';
import { MimaButton, MimaText, Modal } from '../../components';
import React from 'react';

const Logout = ({ closeModal, logout }) => {
	return (
		<Modal closeModal={closeModal}>
			<MimaText variant="subtitle" mb={4} color="var(--color-primary)">
				Are you sure you <br /> want to log out?
			</MimaText>

			<div className={styles.logout}>
				<MimaButton title="Yes" variant="small" onClick={logout} />
				<MimaButton
					title="No"
					variant="small"
					onClick={closeModal}
					buttonColor="var(--color-dark-3)"
				/>
			</div>
		</Modal>
	);
};

export default Logout;
